import React, { useMemo } from 'react';
import cm from 'classnames';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { ReactElement } from 'react';

import { constantStore } from '@stores/constantStore';

import styles from './PackageStatus.module.scss';

const colorByStatus = {
  CREATE: '#9EB3C8',
  PUBLISHED: '#58bf7f',
  FOR_APPROVAL: '#00a5b0',
  NEEDS_IMPROVEMENT: '#dca11d',
};

const { CREATE, PUBLISHED, FOR_APPROVAL, NEEDS_IMPROVEMENT } = constantStore.REPORT_PACKAGE_STATUS;

export const PackageStatus = ({ status, title }: { status: string; title: JSX.Element }): ReactElement => {
  const colorStyle = useMemo(() => {
    const reportStatus =
      Object.keys(constantStore.REPORT_PACKAGE_STATUS).find(
        (key) => constantStore.REPORT_PACKAGE_STATUS[key] === status,
      ) || '';

    return { backgroundColor: colorByStatus[reportStatus] };
  }, [status]);

  return (
    <div className={styles.row}>
      {status && (
        <Tooltip
          hideOnClick={false}
          content={status}
          className={cm({
            [styles.create]: status === CREATE,
            [styles.published]: status === PUBLISHED,
            [styles.approval]: status === FOR_APPROVAL,
            [styles.improvement]: status === NEEDS_IMPROVEMENT,
          })}
        >
          <div style={colorStyle} className={styles.circle} />
        </Tooltip>
      )}
      {title}
    </div>
  );
};
